function main() {
  const needResourceList = [
    window.$,
    window.jQuery,
    window.Swiper,
    window.Lazyload,
  ];

  if (needResourceList.filter(Boolean).length !== needResourceList.length) {
    return setTimeout(main, 240);
  }

  const prods = window.prods;

  let rootEle = document.getElementById("root");
  rootEle.style.zoom = "normal"; //避免zoom尺寸叠加
  let scale = rootEle.clientWidth / 1080;
  rootEle.style.zoom = scale;
  window.addEventListener("resize", function () {
    rootEle.style.zoom = "normal";
    let scale = rootEle.clientWidth / 1080;
    rootEle.style.zoom = scale;
  });

  var lazy = new Lazyload({ distance: 500 });

  jQuery("#nav1").slide({
    mainCell: ".nav11",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 7,
    easing: "swing",
  });

  jQuery("#nav22").slide({
    mainCell: ".nav22",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 8,
  });

  // 倒计时
  function getRandomNum(n, m) {
    let _num = Math.floor((n + 1 - m) * Math.random() + m);
    return _num;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);
    let leftTime = endTime.getTime() - nowTime.getTime();
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }

  function getCutDownTime() {
    let rHour = getRandomNum(4, 12);
    let curTime = new Date();
    endTimeG = curTime.setHours(curTime.getHours() + rHour);
    setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  $(".sp_buy_now").on("click", function () {
    let id = $(this).attr("data-id");
    window.location.href = "/cart/" + id + ":1";
  });

  new Swiper("#banner1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    slidesPerView: "auto",
  });
  new Swiper("#swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    pagination: {
      el: ".pagination1",
      type: "bullets",
      clickable: true,
    },
  });

  $(".buy").click(function () {
    const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
    const offsetTop = targetElement.offsetTop;
    window.scroll({
      top: (offsetTop + 280) * $("div#root").css("zoom"),
      behavior: "smooth",
    });
  });
}

main();
